import { Component, ElementRef, EventEmitter, Output, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { LoaderService } from '../loader.service';
import { ModelserviceService } from '../modelservice.service';

@Component({
  selector: 'app-pop-up',
  templateUrl: './pop-up.component.html'
})
export class PopUpComponent {
  content:any
  @Output() newItemEvent = new EventEmitter<any>();
    constructor(private modalService: ModelserviceService) {
    this.modalService.modelOpen$.subscribe((content:any) => {
      console.log(content,'con')
      console.log('from popup');
      this.content=content
      this.openModel()
    });
  }


  confirmDelete(){
    this.closeModal()
    console.log('close from event')
    this.newItemEvent.emit('true');
  }

    @ViewChild('modalCloseButton') modalCloseButton!: ElementRef;

    closeModal() {
      const button: any = this.modalCloseButton.nativeElement;
      button.click();
    }
  @ViewChild('openModel') modalOpenButton!: ElementRef;
  openModel() {
    const button: any = this.modalOpenButton.nativeElement;
    button.click();

  }

}
